// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"372":"ebd614f1","379":"ebd614f1","528":"d61ed9fa","534":"f1b9c115","541":"1e533890","614":"656193ba","666":"ebd614f1"}[chunkId] + ".chunk.css";
};